import { useEffect } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useStoredListLimit } from '../-useStoredListLimit';

/**
 * Effect-based redirect (not beforeLoad / <Navigate>) so a navigation to
 * `$metaSiteId` briefly settles on that URL — matching the old RR `<Redirect>`
 * hop that create-flow tests observe before the settings redirect completes.
 */
const MetaSiteIndexRedirect = () => {
  const navigate = useNavigate();
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const { metaSiteId } = Route.useParams();
  const limit = useStoredListLimit();

  useEffect(() => {
    navigate({
      to: '/administration/meta-sites/$metaSiteId/settings/$page/$limit',
      params: { metaSiteId, page: '1', limit: String(limit) },
    });
  }, [limit, metaSiteId, navigate]);

  return null;
};

export const Route = createFileRoute('/_secured/administration/meta-sites/$metaSiteId/')({
  component: MetaSiteIndexRedirect,
});
